import { FC } from 'react';
import { useTypedSelector } from '@/store/hooks';
import { ModulesList } from '../../partials/modulesList/ModulesList';
import { CreatorProductModuleConfiguration } from '../../partials/creatorProductModuleConfiguration/CreatorProductModuleConfiguration';
import { CollectionConfiguration } from '../../partials/collectionConfiguration/CollectionConfiguration';

export const Configuration: FC = () => {
	const { options } = useTypedSelector((state) => state.creator);

	if (options.swapDetails.creatorProductModule) return <ModulesList isSwap />;
	if (options.selectedSlot) return <ModulesList />;
	if (options.selectedCreatorProductModule)
		return <CreatorProductModuleConfiguration />;

	return <CollectionConfiguration />;
};
